import { type BackgroundLayerEntry } from "../BackgroundLayers";
import { type CommentTag } from "../comments/CommentViewModel";

export class WebviewerConfig<T> {

  config: T;
  initialized: boolean = false;

  constructor(configDefaults: any) {
    this.config = {
      ...configDefaults,
    }
  }

  setConfig(config: any) {
    throw "setConfig soll überschrieben werden";
  }

  getConfig(): T {
    if (this.initialized === false) {
      throw "not yet initialized";
    }
    return this.config;
  }


  getModellCommentTagSet(): CommentTag[] {
    throw "getModellCommentTagSet soll überschrieben werden";
  }

  getBackgroundLayers(): BackgroundLayerEntry[] {
    throw "getBackgroundLayers soll überschrieben werden";
  }

  getDefaultBackgroundLayerIndex(): number {
    throw "getdefaultBackgroundLayerIndex soll überschrieben werden";
  }

  getadditionalLayers(): BackgroundLayerEntry[]  {
    throw "getadditionalLayers soll überschrieben werden";
  }
}